import React, { useEffect, useState, Component } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown, Phone, Calendar, MessageCircle, MapPin, Mail, Clock, ArrowRight, Facebook, Instagram, Linkedin } from 'lucide-react';
import { Button } from './ui/Button';
import { twMerge } from 'tailwind-merge';
const SERVICES = ['General Medical Consultations', 'Minor Surgical Procedures', 'Safe Medical Circumcision', 'Paternity Testing (DNA)', 'Immunizations', 'Pre-Employment Medical Examinations', 'Family Planning', 'Counseling Services', 'Chronic Disease Management', 'Physiotherapy', 'Optician Services', 'Antenatal Care', 'Postnatal Care', 'Laboratory Services', 'ECG Services', 'Ultrasound Services', 'Dentistry', 'Audiometry', 'Spirometry'];
function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setMobileMenuOpen(false);
    setServicesOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About Us',
    path: '/about'
  }, {
    name: 'Patient Information',
    path: '/patient-information'
  }, {
    name: 'Doctors & Staff',
    path: '/doctors'
  }, {
    name: 'Facilities',
    path: '/facilities'
  }, {
    name: 'Blog',
    path: '/blog'
  }, {
    name: 'FAQ',
    path: '/faq'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <header className={twMerge('fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white', isScrolled ? 'shadow-soft' : '')} data-id="element-269" data-mp="2p7ppkngbafeg">
      {/* Top utility bar — desktop only */}
      <div className="hidden md:block bg-brand-gold text-white" data-id="element-270" data-mp="1ujz42vkl5qeg">
        <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8" data-id="element-271" data-mp="29hzrf17eetwz">
          <div className="flex items-center justify-between h-10 text-sm" data-id="element-272" data-mp="29g6uweqi1q2p">
            <div className="flex items-center gap-6" data-id="element-273" data-mp="24jpx0sthzxcf">
              <span className="flex items-center gap-2" data-id="element-274" data-mp="1gtccdnd8t0rv">
                <Clock className="w-4 h-4 text-white/80" data-id="element-275" data-mp="1gtvk6b96i8s6" />
                Monday – Friday: 8:00 AM – 6:00 PM | Saturday: 9:00 AM - 1:00 PM
              </span>
              <a href="mailto:bookings@maishahealth.co.bw" className="flex items-center gap-2 hover:text-white/80 transition-colors" data-id="element-276" data-mp="1qjngb9wxf9yr">
                <Mail className="w-4 h-4 text-white/80" data-id="element-277" data-mp="y2kws42nwe51" />
                bookings@maishahealth.co.bw
              </a>
              <span className="flex items-center gap-2" data-id="element-278" data-mp="t2yjjumu2xw8">
                <MapPin className="w-4 h-4 text-white/80" data-id="element-279" data-mp="t26vr5zha4gi" />
                Plot 5245, Tsabong, Botswana
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-280" data-mp="39j4xpk3mvc6v">
              {[{
              label: 'WhatsApp',
              href: 'https://wa.me/26773241613',
              Icon: MessageCircle
            }, {
              label: 'Facebook',
              href: '#',
              Icon: Facebook
            }, {
              label: 'Instagram',
              href: '#',
              Icon: Instagram
            }, {
              label: 'LinkedIn',
              href: '#',
              Icon: Linkedin
            }].map(({
              label,
              href,
              Icon
            }) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="w-7 h-7 rounded-full border border-white/50 flex items-center justify-center hover:bg-white hover:text-brand-gold transition-colors" data-id="element-281" data-mp="230y95p6rt9zt">
                  <Icon className="w-3.5 h-3.5" data-id="element-282" data-mp="2dkekpn5eqs8u" />
                </a>)}
            </div>
          </div>
        </div>
      </div>

      {/* Main navigation row */}
      <div className={twMerge('max-w-brand mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-300', isScrolled ? 'py-2' : 'py-4')} data-id="element-283" data-mp="28k0e89jgfqcx">
        <div className="flex items-center justify-between" data-id="element-284" data-mp="318fo6hnqbihe">
          {/* Logo */}
          <Link to="/" className="flex items-center group shrink-0" data-id="element-285" data-mp="2w9unyi8h8ysy">
            <img src="https://cdn.magicpatterns.com/uploads/cndFLouYwME2MiiED8zkcC/logo.jpg" alt="Maisha Medical Center — your health is our devotion" className="h-12 md:h-14 w-auto object-contain" data-id="element-286" data-mp="2salt1a1pauvt" />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-1" data-id="element-287" data-mp="3sitqeh10gpy3">
            <Link to="/" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-288" data-mp="e7x23o3q5zt">
              Home
            </Link>
            <Link to="/about" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-289" data-mp="a41915s5on4l">
              About Us
            </Link>

            {/* Services Dropdown */}
            <div className="relative group" data-id="element-290" data-mp="k0w39chec1d2">
              <button className="flex items-center gap-1 px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)} data-id="element-291" data-mp="o3st9o99mzr1">
                Services <ChevronDown className="w-4 h-4" data-id="element-292" data-mp="2uua5eyelkvas" />
              </button>

              {servicesOpen && <div className="absolute top-full left-1/2 -translate-x-1/2 w-[600px] bg-white shadow-soft-lg rounded-2xl p-6 grid grid-cols-2 gap-x-8 gap-y-3 border border-slate-100" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)} data-id="element-293" data-mp="1zi92253qp95">
                  {SERVICES.map(service => <Link key={service} to={`/services/${service.toLowerCase().replace(/\s+/g, '-')}`} className="text-sm text-slate-600 hover:text-brand-red hover:translate-x-1 transition-all flex items-center gap-2" data-id="element-294" data-mp="kynrowmcx2qk">
                      <div className="w-1.5 h-1.5 rounded-full bg-brand-gold/50" data-id="element-295" data-mp="ppmfeh9od33u" />
                      {service}
                    </Link>)}
                </div>}
            </div>

            <Link to="/patient-information" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-296" data-mp="yqtz9ubg21ee">
              Patient Info
            </Link>
            <Link to="/doctors" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-297" data-mp="1naf8g57bz6qx">
              Doctors
            </Link>
            <Link to="/facilities" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-298" data-mp="1dawr7wit1z2k">
              Facilities
            </Link>
            <Link to="/blog" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-299" data-mp="14dw6q0yuwl4e">
              Blog
            </Link>
            <Link to="/faq" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-300" data-mp="ujxa1hhjxtju">
              FAQ
            </Link>
            <Link to="/contact" className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-brand-red transition-colors" data-id="element-301" data-mp="113l4ufgn5zcf">
              Contact
            </Link>
          </nav>

          {/* CTA & Mobile Toggle */}
          <div className="flex items-center gap-4" data-id="element-302" data-mp="r3ud2ljgtyg1">
            <div className="hidden md:block" data-id="element-303" data-mp="m6u2pyfl29j4">
              <Button href="/book" variant="primary" size="sm" icon={<Calendar className="w-4 h-4" data-id="element-305" data-mp="i6tmq9cu5q9y" />} data-id="element-304" data-mp="m62j7lz9g297">
                Book Appointment
              </Button>
            </div>
            <button className="lg:hidden p-2 text-brand-navy hover:bg-slate-50 rounded-lg" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-306" data-mp="8ee8nn4ntluc">
              {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-307" data-mp="3ul2s6xmt6k72" /> : <Menu className="w-6 h-6" data-id="element-308" data-mp="3qksk9ffghjpk" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="lg:hidden absolute top-full left-0 right-0 bg-white shadow-soft-lg border-t border-slate-100 max-h-[80vh] overflow-y-auto" data-id="element-309" data-mp="264kp61bjzcpy">
          <div className="px-4 py-6 flex flex-col gap-4" data-id="element-310" data-mp="2f2wqaxa1pswn">
            {navLinks.map(link => <Link key={link.name} to={link.path} className="text-lg font-medium text-brand-navy py-2 border-b border-slate-50" data-id="element-311" data-mp="2k2j3j6pvj95g">
                {link.name}
              </Link>)}
            <div className="py-2 border-b border-slate-50" data-id="element-312" data-mp="1rb94uuvjza1r">
              <div className="text-lg font-medium text-brand-navy mb-3" data-id="element-313" data-mp="1wbwvhffvdovg">
                Services
              </div>
              <div className="flex flex-col gap-3 pl-4" data-id="element-314" data-mp="214q0m4f92z82">
                {SERVICES.slice(0, 8).map(service => <Link key={service} to={`/services/${service.toLowerCase().replace(/\s+/g, '-')}`} className="text-sm text-slate-600" data-id="element-315" data-mp="13m6pjtoe5taf">
                    {service}
                  </Link>)}
                <Link to="/services" className="text-sm font-medium text-brand-red flex items-center gap-1 mt-2" data-id="element-316" data-mp="nutivixrj92l">
                  View All Services <ArrowRight className="w-4 h-4" data-id="element-317" data-mp="xqeg73rvzl60" />
                </Link>
              </div>
            </div>
            <Button href="/book" variant="primary" fullWidth className="mt-4" data-id="element-318" data-mp="11js6vkkcu8">
              Book Appointment
            </Button>
          </div>
        </div>}
    </header>;
}
function Footer() {
  return <footer className="bg-brand-navy text-white pt-20 pb-10" data-id="element-319" data-mp="9zhbaayido49">
      <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8" data-id="element-320" data-mp="etlk6zrc467z">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-321" data-mp="3dikf8cg8um4n">
          {/* Brand */}
          <div data-id="element-322" data-mp="3igc8b9smkeaf">
            <Link to="/" className="inline-flex mb-6" data-id="element-323" data-mp="3ifua47mejpzv">
              <span className="bg-white rounded-2xl p-3 inline-flex" data-id="element-324" data-mp="1zlr3ujckkgq8">
                <img src="https://cdn.magicpatterns.com/uploads/cndFLouYwME2MiiED8zkcC/logo.jpg" alt="Maisha Medical Center — your health is our devotion" className="h-16 w-auto object-contain" data-id="element-325" data-mp="1zjwt1xv0i4zv" />
              </span>
            </Link>
            <p className="text-slate-300 text-sm leading-relaxed mb-6" data-id="element-326" data-mp="1lom2uxrpq81u">
              Providing comprehensive healthcare services, diagnostics,
              physiotherapy, maternal care, and specialist consultations across
              Botswana.
            </p>
            <div className="flex items-center gap-4" data-id="element-327" data-mp="17vmpp2fekpxg">
              {[{
              label: 'Facebook',
              href: '#',
              Icon: Facebook
            }, {
              label: 'Instagram',
              href: '#',
              Icon: Instagram
            }, {
              label: 'LinkedIn',
              href: '#',
              Icon: Linkedin
            }].map(({
              label,
              href,
              Icon
            }) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-colors" data-id="element-328" data-mp="o6ow20wjl4nd">
                  <Icon className="w-5 h-5 text-white" data-id="element-329" data-mp="16yhnhqvyqhsz" />
                </a>)}
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-330" data-mp="t6bhgxmixr79">
            <h3 className="font-heading font-semibold text-lg mb-6 text-white" data-id="element-331" data-mp="x9hoi7hgnmes">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-332" data-mp="1ky99oewmv4i2">
              {['About Us', 'Patient Information', 'Doctors & Staff', 'Facilities', 'Blog', 'Contact'].map(item => <li key={item} data-id="element-333" data-mp="35hmfu4cbycue">
                  <Link to={`/${item.toLowerCase().replace(/\s+/g, '-').replace('&-', '')}`} className="text-slate-300 hover:text-brand-gold transition-colors text-sm flex items-center gap-2" data-id="element-334" data-mp="35gbbo3ez332r">
                    <ChevronDown className="w-3 h-3 -rotate-90 text-brand-gold" data-id="element-335" data-mp="2rhlhowng9jim" />
                    {item}
                  </Link>
                </li>)}
              <li data-id="element-336" data-mp="2mkbjoslzvzj6">
                <Link to="/privacy" className="text-slate-300 hover:text-brand-gold transition-colors text-sm flex items-center gap-2" data-id="element-337" data-mp="2mkv3yfz4b00d">
                  <ChevronDown className="w-3 h-3 -rotate-90 text-brand-gold" data-id="element-338" data-mp="2wirdj3cepmwd" />
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-339" data-mp="br8s1b13bgvo">
                <Link to="/terms" className="text-slate-300 hover:text-brand-gold transition-colors text-sm flex items-center gap-2" data-id="element-340" data-mp="bpxlx4k69x1e">
                  <ChevronDown className="w-3 h-3 -rotate-90 text-brand-gold" data-id="element-341" data-mp="2meufwzp7ecdg" />
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-342" data-mp="2vg27z014mgz3">
            <h3 className="font-heading font-semibold text-lg mb-6 text-white" data-id="element-343" data-mp="2vcegs7j5m6nj">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-344" data-mp="35cor9kdt0zz0">
              <li className="flex items-start gap-3 text-sm text-slate-300" data-id="element-345" data-mp="35bdrdvnhccd6">
                <MapPin className="w-5 h-5 text-white shrink-0 mt-0.5" data-id="element-346" data-mp="3a2vjrvbft4mj" />
                <span data-id="element-347" data-mp="3e4z4zbnwrnl0">Plot 5245, Tsabong, Botswana</span>
              </li>
              <li className="flex flex-col gap-1 text-sm text-slate-300" data-id="element-348" data-mp="3e47cwatis7zh">
                <span className="flex items-center gap-3" data-id="element-349" data-mp="3j5eflvgt2gza">
                  <Phone className="w-5 h-5 text-white shrink-0" data-id="element-350" data-mp="3o2wqvsiap8ag" />
                  <a href="tel:+2676540244" className="hover:text-brand-gold transition-colors" data-id="element-351" data-mp="3o128akuhxs9j">
                    +267 6540244
                  </a>
                </span>
                <span className="flex items-center gap-3" data-id="element-352" data-mp="3o8nr6zrcph16">
                  <MessageCircle className="w-5 h-5 text-white shrink-0" data-id="element-353" data-mp="3o974g3623h8v" />
                  <a href="https://wa.me/26773241613" target="_blank" rel="noopener noreferrer" className="hover:text-brand-gold transition-colors" data-id="element-354" data-mp="3k8n8v414slou">
                    +267 73241613 (WhatsApp)
                  </a>
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm text-slate-300" data-id="element-355" data-mp="7120mbbwqyg2">
                <Mail className="w-5 h-5 text-white shrink-0" data-id="element-356" data-mp="6yzcxxy89hei" />
                <a href="mailto:bookings@maishahealth.co.bw" className="hover:text-brand-gold transition-colors" data-id="element-357" data-mp="13jhspz0ngbke">
                  bookings@maishahealth.co.bw
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-slate-300" data-id="element-358" data-mp="2xywxnqc2vv2d">
                <Clock className="w-5 h-5 text-white shrink-0 mt-0.5" data-id="element-359" data-mp="2y0zlq4to7e4g" />
                <span data-id="element-360" data-mp="2j9hccpvbghu2">
                  Mon - Fri: 8:00 AM - 6:00 PM
                  <br data-id="element-361" data-mp="2o8btlndmxyc2" />
                  Sat: 9:00 AM - 1:00 PM
                  <br data-id="element-362" data-mp="2o6r103avspgu" />
                  Sun: Closed
                </span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-363" data-mp="2f96ticmfdwxs">
            <h3 className="font-heading font-semibold text-lg mb-6 text-white" data-id="element-364" data-mp="2f9qddyvmyveg">
              Newsletter
            </h3>
            <p className="text-slate-300 text-sm mb-4" data-id="element-365" data-mp="20diwb7fiya3e">
              Subscribe to receive health tips and clinic updates.
            </p>
            <form className="flex flex-col gap-3" onSubmit={e => e.preventDefault()} data-id="element-366" data-mp="3uoxn7rk9ufkq">
              <input type="email" placeholder="Your email address" className="bg-white/10 border border-white/20 rounded-lg px-4 py-2.5 text-sm text-white placeholder:text-slate-400 focus:outline-none focus:border-brand-gold" data-id="element-367" data-mp="3icpxq3mibf9" />
              <Button variant="primary" fullWidth data-id="element-368" data-mp="1xri53es62ffl">
                Subscribe
              </Button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-369" data-mp="26relkt4ek7zk">
          <p className="text-slate-400 text-sm" data-id="element-370" data-mp="22qcnifm821z6">
            © {new Date().getFullYear()} Maisha Medical Center Botswana. All
            rights reserved.
          </p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-slate-400" data-id="element-371" data-mp="2gn87h340hdu0">
            <span className="font-semibold text-slate-300" data-id="element-372" data-mp="2bool51lia014">Useful Links:</span>
            <a href="https://www.bomra.co.bw/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-373" data-mp="mbtiioitrifb">
              BoMRA
            </a>
            <a href="https://www.ilo.org/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-374" data-mp="i4d2ofbwlxm">
              ILO
            </a>
            <a href="https://www.who.int/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-375" data-mp="a6vysetsqa03">
              World Health Organization (WHO)
            </a>
          </div>
        </div>
      </div>
    </footer>;
}
function FloatingActions() {
  const whatsappMessage = encodeURIComponent('Hello Maisha Medical Center.\nI would like to book an appointment.\nName:\nPhone:\nPreferred Service:\nPreferred Date:\nPreferred Time:\n\nPlease assist me.');
  return <>
      {/* Desktop Floating */}
      <div className="hidden md:flex fixed bottom-8 right-8 flex-col gap-4 z-50" data-id="element-376" data-mp="12vbbuvtdai8s">
        <a href={`https://wa.me/26773241613?text=${whatsappMessage}`} target="_blank" rel="noopener noreferrer" className="w-14 h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-soft-lg hover:scale-110 transition-transform relative group" data-id="element-377" data-mp="2ndlu8m71g49f">
          <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" data-id="element-378" data-mp="28pr1x6wy01wv" />
          <MessageCircle className="w-7 h-7" data-id="element-379" data-mp="23s91k4wzqv0h" />
          <span className="absolute right-full mr-4 bg-white text-slate-800 text-sm font-medium py-1.5 px-3 rounded-lg shadow-soft opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none" data-id="element-380" data-mp="1zpkthzg3ps4k">
            Chat on WhatsApp
          </span>
        </a>
      </div>

      {/* Mobile Sticky Bottom Bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-slate-100 shadow-[0_-4px_20px_rgba(0,0,0,0.05)] z-50 px-4 py-3 flex items-center justify-between gap-3 pb-safe" data-id="element-381" data-mp="3p2y05vbors8u">
        <a href={`https://wa.me/26773241613?text=${whatsappMessage}`} className="flex-1 flex flex-col items-center justify-center gap-1 text-[#25D366]" data-id="element-382" data-mp="fsjl492rz6m4">
          <MessageCircle className="w-5 h-5" data-id="element-383" data-mp="639ukxnkxw04" />
          <span className="text-[10px] font-medium" data-id="element-384" data-mp="61ynanuxe649">WhatsApp</span>
        </a>
        <Link to="/book" className="flex-[2] bg-brand-red text-white py-2.5 rounded-xl flex items-center justify-center gap-2 font-medium text-sm shadow-md" data-id="element-385" data-mp="14f9tq61xxdd">
          <Calendar className="w-4 h-4" data-id="element-386" data-mp="3o8v78b5ns8nr" />
          Book Now
        </Link>
        <a href="tel:+2676540244" className="flex-1 flex flex-col items-center justify-center gap-1 text-brand-navy" data-id="element-387" data-mp="3j9rz2hudtmbk">
          <Phone className="w-5 h-5" data-id="element-388" data-mp="3edbefxme5q38" />
          <span className="text-[10px] font-medium" data-id="element-389" data-mp="1hiyibr8nqz1z">Call Us</span>
        </a>
      </div>
    </>;
}
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-390" data-mp="1l149irbn8pmn">
      <Header data-id="element-391" data-mp="1l0mfm1cgenhw" />
      <main className="flex-1 pt-[72px] md:pt-[128px] pb-16 md:pb-0" data-id="element-392" data-mp="1l0vy73v65sdk">
        {children}
      </main>
      <Footer data-id="element-393" data-mp="1p0mufn3gt0ph" />
      <FloatingActions data-id="element-394" data-mp="1p0d5m2u5ozld" />
    </div>;
}